// extracted by css-extract-rspack-plugin
var _1 = "yS8sTmdS3PnC4NSY-cgZzg--";
var _2 = "_0MOAPizuRSEpDO6IGKUMxQ--";
export { _1 as "children", _2 as "wrapper" }
